var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.725894 13.0072C0.582875 13.0076 0.442963 12.9655 0.323904 12.8862C0.204845 12.807 0.112004 12.6942 0.0571564 12.5621C0.00230841 12.43 -0.0120754 12.2846 0.0158294 12.1443C0.0437342 12.0041 0.11267 11.8752 0.213894 11.7742L5.49589 6.50219L0.213894 1.23219C0.0875687 1.0946 0.0193114 0.913499 0.0233884 0.726753C0.0274653 0.540006 0.103561 0.362061 0.235771 0.230109C0.367982 0.0981573 0.546075 0.0224097 0.732829 0.0186978C0.919583 0.014986 1.10055 0.0835971 1.23789 0.210192L7.03189 5.99219C7.09908 6.05925 7.15238 6.1389 7.18875 6.22659C7.22511 6.31427 7.24383 6.40827 7.24383 6.50319C7.24383 6.59812 7.22511 6.69211 7.18875 6.7798C7.15238 6.86748 7.09908 6.94713 7.03189 7.01419L1.23789 12.7962C1.17067 12.8634 1.09083 12.9166 1.00296 12.9528C0.915091 12.989 0.820931 13.0075 0.725894 13.0072Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.c3b295f6faab3347864feb25b9998d87.svg";
export { ForwardRef as ReactComponent };